import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import * as wanakana from "wanakana";

export const handleKatakanaToFurigana = (value: string) => {
  return wanakana.toHiragana(value, { passRomaji: true });
};

export const convertNumberToZipCode = (value: string) => {
  if (!value) return "";

  const cleanedValue = value.replace(/[^\d０-９]/g, "");

  if (cleanedValue.length !== 7) return value;

  return `${cleanedValue.slice(0, 3)}-${cleanedValue.slice(3)}`;
};

export const convertZipCodeToNumber = (zipCode: string) => {
  if (!zipCode) return;
  return zipCode.replace("-", "");
};

export const convertNumberToCommas = (value: string) => {
  if (value) {
    const normalizedValue = convertFullWidthToHalfWidth(value.toString());
    if (/^-?[0-9]+(\.[0-9]*)?$/.test(normalizedValue)) {
      const [integerPart, decimalPart] = normalizedValue.split(".");
      const formattedIntegerPart = parseInt(integerPart.replace(/,/g, "")).toLocaleString("en-GB");
      return decimalPart !== undefined ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    }
  }
  return value;
};

export const convertCommasToNumber = (value: string) => {
  return value.replace(/,/g, "");
};
